module.exports = "/_next/static/resources/pack-2d3000d0849bd5ee5f5e05072ac00153.jpg";